import { useState } from 'react';
import { useReduxState } from 'hooks';
import { PathsViewAvailable } from 'components/paths';

import type { HomeModuleProps } from './Home';

const HomePathsAvailable = ({
  defaultTitle,
  limit,
  module,
  spacing
}: HomeModuleProps) => {
  const { language } = useReduxState();

  const [noData, setNoData] = useState(false);

  if (!module) return null;

  const description =
    module.descriptionTranslations?.[language] || module.description;

  const title =
    module.titleTranslations?.[language] || module.title || defaultTitle;

  return (
    <div {...(!noData ? { style: { marginTop: spacing } } : {})}>
      <PathsViewAvailable
        description={description}
        hideIfNoData={true}
        isHomeView={true}
        limitPerPage={module.limit || limit}
        onNoData={(hasNoData) => setNoData(!hasNoData)}
        showAllLinkHref="/paths?type=available"
        title={title}
        titleShowCount={false}
      />
    </div>
  );
};

export default HomePathsAvailable;
